/* wl-modales.js — la machinerie des modales, sortie de la page le 26/08/2026 (phase 2a du regime du document). Quatre blocs, dans l'ordre d'origine ; les libelles traduits arrivent par window.WLMTXT, pose inline par la section. */

(function () {
  'use strict';

  /* ==================================================================
     A. LES ONGLETS DES TARIFS SONT TOUS FERMES A L'OUVERTURE
     ==================================================================
     Le premier — « Europe (29 pays) » — porte la classe « open » dans le
     code de la page. Le client tombait donc sur une liste de pays deployee
     avant meme d'avoir choisi ce qu'il voulait voir.

     Ceci vaut pour le telephone ET pour l'ordinateur : c'est un choix de
     comportement, pas une adaptation d'ecran. */
  function fermerLesOnglets() {
    var zones = document.querySelectorAll('.fixation-popup .fixation-zone.open');
    for (var i = 0; i < zones.length; i++) { zones[i].classList.remove('open'); }
  }

  function surveillerLesTarifs() {
    var pop = document.querySelector('.fixation-popup');
    if (!pop) { return false; }
    if (pop.dataset.wlmodSuivi === '1') { return true; }
    pop.dataset.wlmodSuivi = '1';
    fermerLesOnglets();
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (pop.classList.contains('active')) { fermerLesOnglets(); }
      }).observe(pop, { attributes: true, attributeFilter: ['class'] });
    }
    return true;
  }

  /* ==================================================================
     B. LE BOUTON « FERMER » AU BAS DE LA FEUILLE SUR MESURE
     ==================================================================
     La feuille fait 1 284px de contenu pour 670 de fenetre. Arrive en bas,
     le client n'a plus rien sous la main : il lui faut remonter chercher
     la croix. On lui pose donc une sortie a l'endroit ou il se trouve. */
  function poserLeBoutonDuBas() {
    var modale = document.querySelector('.wlk-cs-modal');
    if (!modale) { return false; }
    if (modale.querySelector('.wlmod-fermer')) { return true; }
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wlmod-fermer';
    b.textContent = window.WLMTXT.vFermer;
    b.addEventListener('click', function () {
      /* On reutilise la croix d'origine plutot que de fermer nous-memes :
         elle sait ce que le theme doit remettre en etat en partant. */
      var croix = modale.querySelector('.wlk-cs-modal__close');
      if (croix) { croix.click(); return; }
      var voile = document.querySelector('.wlk-popup-overlay');
      if (voile) { voile.classList.remove('open'); }
    });
    modale.appendChild(b);
    return true;
  }

  /* ==================================================================
     C. LA PHOTO DU VISUALISATEUR : CHOISIR, PAS SEULEMENT PHOTOGRAPHIER
     ==================================================================
     Le champ porte « capture="environment" ». Cet attribut ne veut pas dire
     « propose l'appareil photo » mais « n'utilise QUE l'appareil photo » :
     sur telephone, le systeme ouvre directement la camera et la
     photothèque devient inaccessible. Or un client a souvent deja la photo
     de son mur dans sa pellicule.
     On retire l'attribut. Le systeme rend alors son choix habituel —
     appareil photo, photothèque ou fichiers — sans rien enlever.

     Le fichier du visualisateur ne doit pas etre touche : on agit donc ici,
     sur la page, et on recommence si le theme reconstruit le champ. */
  function libererLeChoixDePhoto() {
    var zone = document.querySelector('.wv-upload-area');
    var cible = document.getElementById('wv-file-input');
    if (!zone || !cible) { return 0; }
    if (zone.parentNode.querySelector('.wlmod-photo')) { return 1; }

    /* Le champ d'origine portait « capture="environment" ». Cet attribut ne
       veut pas dire « propose l'appareil photo » mais « n'utilise QUE
       l'appareil photo » : la photothèque devenait inaccessible. En le
       retirant, j'ai obtenu l'inverse — le systeme n'ouvrait plus que le
       navigateur de fichiers.
       On ne laisse donc plus le systeme decider : DEUX boutons, deux
       champs, et le client choisit lui-meme. Le champ d'origine reste le
       seul destinataire : on y depose le fichier choisi et on previent le
       theme comme s'il venait d'etre rempli a la main. */
    cible.removeAttribute('capture');

    function fabriquerChamp(avecAppareil) {
      var c = document.createElement('input');
      c.type = 'file';
      c.accept = 'image/*';
      if (avecAppareil) { c.setAttribute('capture', 'environment'); }
      c.style.display = 'none';
      c.addEventListener('change', function () {
        if (!c.files || !c.files.length) { return; }
        try {
          var dt = new DataTransfer();
          dt.items.add(c.files[0]);
          cible.files = dt.files;
          cible.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (err) {
          /* Navigateur sans DataTransfer : on retombe sur le champ
             d'origine, qui ouvrira au moins l'un des deux chemins. */
          cible.click();
        }
        c.value = '';
      });
      return c;
    }

    var appareil = fabriquerChamp(true);
    var fichier = fabriquerChamp(false);

    var barre = document.createElement('div');
    barre.className = 'wlmod-photo';

    function bouton(texte, champ) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = texte;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();   /* la zone entiere ouvre deja un champ */
        champ.click();
      });
      return b;
    }

    barre.appendChild(bouton(window.WLMTXT.vPrendre, appareil));
    barre.appendChild(bouton(window.WLMTXT.vChoisir, fichier));
    barre.appendChild(appareil);
    barre.appendChild(fichier);
    zone.parentNode.insertBefore(barre, zone.nextSibling);
    return 1;
  }


  /* ==================================================================
     D. « VOTRE CHOIX SUR MESURE » dans la feuille taille perso
     ==================================================================
     La partie prix ne disait que « Prix sur mesure  269,90 € » : rien ne
     rappelait CE qu'on achetait. On reprend la grammaire de la fiche —
     la taille et le support a gauche, le prix a droite, la mensualite en
     dessous — et on garde les noeuds d'origine du prix et de Klarna, que
     le theme continue de mettre a jour tout seul. */
  function poserLeChoixSurMesure() {
    /* TELEPHONE UNIQUEMENT. La mise en forme de ce bloc vit dans le
       « @media (max-width: 999px) » : le monter sur un ordinateur
       deplacerait le prix dans une boite sans style, et casserait la
       rangee d'origine qui, elle, y reste visible. */
    if (window.matchMedia('(min-width: 1000px)').matches) { return true; }
    var m = document.querySelector('.wlk-cs-modal');
    if (!m) { return false; }
    if (m.querySelector('.wlmod-choix')) { return true; }
    var rangee = m.querySelector('.wlk-price-row');
    var valeur = m.querySelector('.wlk-price-value');
    var klarna = m.querySelector('.wlk-klarna-row');
    if (!rangee || !valeur) { return false; }

    var bloc = document.createElement('div');
    bloc.className = 'wlmod-choix';
    var titre = document.createElement('p');
    titre.className = 'wlmod-choix-titre';
    titre.textContent = window.WLMTXT.t0;
    var grille = document.createElement('div');
    grille.className = 'wlmod-choix-grille';
    var taille = document.createElement('span');
    taille.className = 'wlmod-taille';
    var support = document.createElement('span');
    support.className = 'wlmod-support';

    grille.appendChild(taille);
    grille.appendChild(valeur);       /* le noeud d'origine, deplace */
    grille.appendChild(support);
    if (klarna) { grille.appendChild(klarna); }
    bloc.appendChild(titre);
    bloc.appendChild(grille);
    rangee.parentNode.insertBefore(bloc, rangee.nextSibling);

    function lireLaTaille() {
      var d = m.querySelector('.wlk-dims');
      if (!d) { return ''; }
      /* « 140cm · Largeur × 80cm · Hauteur » devient « 140 × 80 cm » */
      var n = (d.textContent || '').match(/(\d+(?:[.,]\d+)?)\s*cm/g);
      if (n && n.length >= 2) {
        return parseFloat(n[0]) + ' × ' + parseFloat(n[1]) + ' cm';
      }
      return (d.textContent || '').replace(/\s+/g, ' ').trim();
    }
    function lireLeSupport() {
      var a = m.querySelector('.wlk-material__btn.active') ||
              m.querySelector('.wlk-material__btn');
      if (!a) { return ''; }
      var n = a.querySelector('.wl-nm');
      if (!n) { return ''; }
      /* Le nom est coupe en deux lignes sur la carte — « Verre<br>Acrylique ».
         « textContent » recolle les morceaux sans rien mettre entre les deux :
         un retour a la ligne n'est pas un espace, et le rappel affichait
         « VerreAcrylique ». On remet l'espace que le « <br> » remplace. */
      return (n.innerHTML || '').replace(/<br\s*\/?>/gi, ' ')
                                .replace(/<[^>]*>/g, '')
                                .replace(/\s+/g, ' ').trim();
    }
    /* DEUX PRECAUTIONS, apprises a mes depens : ma premiere version
       surveillait TOUTE la feuille et y ecrivait ces deux lignes. Chaque
       ecriture declenchait l'observateur, qui reecrivait, sans fin : la
       page se figeait.
         1. on n'ecrit QUE si la valeur a change ;
         2. on ne surveille QUE les deux sources — la reglette et le choix
            de matiere — jamais le bloc qu'on ecrit. */
    function rafraichir() {
      var t1 = lireLaTaille();
      var s1 = lireLeSupport();
      if (taille.textContent !== t1) { taille.textContent = t1; }
      if (support.textContent !== s1) { support.textContent = s1; }
    }
    rafraichir();
    if (window.MutationObserver) {
      var source1 = m.querySelector('.wlk-dims');
      var source2 = m.querySelector('.wlk-material');
      if (source1) {
        new MutationObserver(rafraichir).observe(source1, {
          subtree: true, childList: true, characterData: true
        });
      }
      if (source2) {
        new MutationObserver(rafraichir).observe(source2, {
          subtree: true, attributes: true, attributeFilter: ['class']
        });
      }
    }
    return true;
  }

  /* ==================================================================
     E. LA LOUPE DES FINITIONS : ouvrir au doigt, puis faire defiler
     ==================================================================
     Deux manques : il fallait viser la petite loupe en coin — un appui sur
     la photo elle-meme ne faisait rien — et une fois agrandie, la photo
     etait seule : impossible d'aller voir les six autres du meme support.
     On ajoute donc l'ouverture au clic sur la photo, et des fleches qui
     font le tour des sept photos DU MEME COTE. */
  function brancherLaLoupeDesFinitions() {
    /* TELEPHONE UNIQUEMENT, comme demande. Sur ordinateur la fenetre
       d'agrandissement garde son comportement d'origine. */
    if (window.matchMedia('(min-width: 1000px)').matches) { return true; }
    var w = document.querySelector('.wlf');
    var loupe = document.getElementById('wlf-loupe');
    if (!w || !loupe) { return false; }
    if (w.dataset.wlmodLoupe === '1') { return true; }
    w.dataset.wlmodLoupe = '1';

    var img = loupe.querySelector('[data-wlf-loupe-img]');
    var liste = [];
    var rang = 0;

    /* L'adresse d'une photo n'existe que dans une regle de style attachee a
       sa classe : on la lit en posant une boite temporaire qui la porte. */
    var cache = {};
    function adresseDe(classe) {
      if (cache[classe]) { return cache[classe]; }
      var d = document.createElement('div');
      d.className = 'wlf-vue ' + classe;
      d.style.cssText = 'position:absolute;left:-9999px;top:0;width:8px;height:8px;';
      document.body.appendChild(d);
      var u = getComputedStyle(d).backgroundImage || '';
      d.parentNode.removeChild(d);
      var r = /url\(["']?(.*?)["']?\)/.exec(u);
      cache[classe] = r ? r[1] : '';
      return cache[classe];
    }

    function cadran() {
      var c = loupe.querySelector('.wlmod-loupe-cpt');
      if (c) { c.textContent = (rang + 1) + ' / ' + liste.length; }
      if (img && liste.length) { img.src = adresseDe(liste[rang]); }
    }

    function aller(pas) {
      if (!liste.length) { return; }
      rang = (rang + pas + liste.length) % liste.length;
      cadran();
    }

    if (!loupe.querySelector('.wlmod-loupe-nav')) {
      var nav = document.createElement('div');
      nav.className = 'wlmod-loupe-nav';
      var g = document.createElement('button');
      g.type = 'button';
      g.className = 'wlmod-prec';
      g.setAttribute('aria-label', window.WLMTXT.t1);
      g.textContent = '‹';
      var cpt = document.createElement('span');
      cpt.className = 'wlmod-loupe-cpt';
      var d2 = document.createElement('button');
      d2.type = 'button';
      d2.className = 'wlmod-suiv';
      d2.setAttribute('aria-label', window.WLMTXT.t2);
      d2.textContent = '›';
      g.addEventListener('click', function (e) { e.stopPropagation(); aller(-1); });
      d2.addEventListener('click', function (e) { e.stopPropagation(); aller(1); });
      nav.appendChild(g);
      nav.appendChild(cpt);
      nav.appendChild(d2);
      loupe.appendChild(nav);
    }

    /* Le glissement du doigt, gauche-droite. */
    var depart = null;
    loupe.addEventListener('touchstart', function (e) {
      depart = (e.touches && e.touches.length === 1) ? e.touches[0].clientX : null;
    }, { passive: true });
    loupe.addEventListener('touchend', function (e) {
      if (depart === null || !e.changedTouches || !e.changedTouches.length) { return; }
      var ecart = e.changedTouches[0].clientX - depart;
      depart = null;
      if (Math.abs(ecart) > 40) { aller(ecart < 0 ? 1 : -1); }
    }, { passive: true });

    /* Un appui sur la photo ouvre l'agrandissement, comme la petite loupe. */
    w.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) { return; }
      if (e.target.closest('[data-wlf-zoom]')) { return; }
      var scene = e.target.closest('.wlf-scene');
      if (!scene) { return; }
      var z = scene.querySelector('[data-wlf-zoom]');
      if (z) { e.preventDefault(); z.click(); }
    }, false);

    /* A chaque ouverture, on retient de quel cote elle vient et la liste des
       sept photos de ce cote. */
    w.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) { return; }
      var scene = e.target.closest('.wlf-scene');
      if (!scene) { return; }
      var cote = scene.closest('[data-wlf-cote]') || scene.parentElement;
      var bande = cote ? cote.querySelector('.wlf-vign') : null;
      liste = bande ? [].map.call(bande.children, function (b) {
        return b.getAttribute('data-wlf-photo') || '';
      }).filter(Boolean) : [];
      var vue = scene.querySelector('[data-wlf-vue]');
      var actuelle = '';
      if (vue) {
        var cl = (vue.className || '').split(/\s+/);
        for (var i = 0; i < cl.length; i++) {
          if (/^wlf-v\d+$/.test(cl[i])) { actuelle = cl[i]; }
        }
      }
      rang = Math.max(0, liste.indexOf(actuelle));
      window.setTimeout(cadran, 60);
    }, true);

    return true;
  }

  /* ==================================================================
     F. LE CHIFFRE DU POIDS
     ==================================================================
     Il s'affichait en 49px dans un carre de 113 : il debordait. Ma regle
     « font-size: 21px !important » ne servait a rien — le theme pose la
     taille en STYLE EN LIGNE avec « !important », et une declaration en
     ligne l'emporte toujours sur une feuille de style. On repond donc sur
     le meme terrain, en ligne, et seulement si la valeur differe : sans ce
     test, l'observateur se declencherait sur sa propre ecriture. */
  function ajusterLePoids() {
    var m = document.querySelector('.wlk-cs-modal');
    if (!m) { return false; }
    if (window.matchMedia('(min-width: 1000px)').matches) { return true; }
    var v = m.querySelector('.wlk-sq-weight-value');
    var l = m.querySelector('.wlk-sq-weight-label');
    if (!v) { return false; }
    if (v.style.getPropertyValue('font-size') !== '21px') {
      v.style.setProperty('font-size', '21px', 'important');
      v.style.setProperty('line-height', '1.1', 'important');
    }
    if (l && l.style.getPropertyValue('font-size') !== '10.5px') {
      l.style.setProperty('font-size', '10.5px', 'important');
      l.style.setProperty('line-height', '1.25', 'important');
    }
    if (!v.dataset.wlmodPoids) {
      v.dataset.wlmodPoids = '1';
      if (window.MutationObserver) {
        new MutationObserver(ajusterLePoids).observe(v, {
          attributes: true, attributeFilter: ['style']
        });
      }
    }
    return true;
  }

  /* ==================================================================
     G. LA PAGE RESTE OU ELLE EST TANT QU'UNE FENETRE EST OUVERTE
     ==================================================================
     Le voile d'une fenetre n'empeche pas le doigt de faire defiler la
     fiche derriere lui : on ouvrait les tarifs, on faisait glisser, et
     c'est la page produit qui bougeait.
     On fige le corps de page en position fixe — la seule methode qui
     tienne sur telephone — et on note la hauteur ou l'on etait pour l'y
     ramener exactement a la fermeture. Sans cette memoire, refermer une
     fenetre renverrait le client tout en haut de la fiche. */
  var hauteurMemorisee = 0;

  function fenetreOuverte() {
    return !!(document.querySelector('.fixation-popup.active') ||
              document.querySelector('.wv-modal-overlay.active') ||
              document.querySelector('.wlk-popup-overlay.open') ||
              document.querySelector('.wlf.ouvert') ||
              document.querySelector('.wlf-loupe.ouvert'));
  }

  function revoirLeGel() {
    var racine = document.documentElement;
    var fige = racine.classList.contains('wlmod-fige');
    /* TELEPHONE UNIQUEMENT — et ce n'est pas une precaution de confort.
       Le decalage du corps est pose EN LIGNE par ce script, alors que la
       regle qui le rend inoffensif (« position: fixed ») vit dans le
       « @media (max-width: 999px) ». Sur un ordinateur, le corps reste en
       « position: relative » : un « top: -1200px » y decalerait toute la
       page pour de bon. */
    if (window.matchMedia('(min-width: 1000px)').matches) {
      if (fige) {
        racine.classList.remove('wlmod-fige');
        document.body.style.top = '';
      }
      return;
    }
    var ouverte = fenetreOuverte();
    if (ouverte && !fige) {
      hauteurMemorisee = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = (-hauteurMemorisee) + 'px';
      racine.classList.add('wlmod-fige');
      /* La feuille vient de s'ouvrir : c'est le moment de recaler la croix
         sur son coin. On repasse un peu plus tard, le temps que son
         mouvement d'ouverture soit termine. */
      window.setTimeout(placerLaCroix, 60);
      window.setTimeout(placerLaCroix, 420);
    } else if (!ouverte && fige) {
      racine.classList.remove('wlmod-fige');
      document.body.style.top = '';
      window.scrollTo(0, hauteurMemorisee);
    }
  }

  function surveillerLesFenetres() {
    if (!window.MutationObserver) { return true; }
    var cibles = ['.fixation-popup', '.wv-modal-overlay', '.wlk-popup-overlay',
                  '.wlf', '.wlf-loupe'];
    var posees = 0;
    for (var i = 0; i < cibles.length; i++) {
      var e = document.querySelector(cibles[i]);
      if (!e) { continue; }
      posees += 1;
      if (e.dataset.wlmodGel === '1') { continue; }
      e.dataset.wlmodGel = '1';
      /* On surveille les FENETRES, jamais la page : c'est la page que l'on
         modifie, et s'observer soi-meme fait tourner en rond. */
      new MutationObserver(revoirLeGel).observe(e, {
        attributes: true, attributeFilter: ['class', 'hidden', 'style']
      });
    }
    revoirLeGel();
    return posees >= 4;
  }

  /* ==================================================================
     H. OU SE POSE LA CROIX DE LA FEUILLE SUR MESURE
     ==================================================================
     Elle est accrochee a l'ecran, pas au contenu : on lui donne les
     coordonnees du coin haut droit de la feuille. La feuille ne bouge pas
     quand son contenu defile, donc la croix reste ou elle est. */
  /* ==================================================================
     I. L'ECHANTILLON DE MATIERE, A FLEUR DU CADRE DANS LES DEUX ETATS
     ==================================================================
     La carte choisie porte une bordure de 3px, l'autre de 1px, mais leur
     contenu reste a la meme hauteur absolue : l'echantillon touche donc le
     cadre d'un cote et flotte de l'autre. J'ai d'abord vise une valeur en
     dur — deux, puis trois, puis quatre pixels. C'est fragile : l'ecart
     depend de l'etat, et l'etat change au clic.
     On mesure donc l'ecart reel de chaque carte et on applique exactement
     ce qu'il faut. On n'ecrit que si la valeur change, sinon l'observateur
     se declencherait sur sa propre ecriture. */
  function callerLesEchantillons() {
    if (window.matchMedia('(min-width: 1000px)').matches) { return true; }
    var cartes = document.querySelectorAll('.wlk-cs-modal .wlk-material__btn');
    if (!cartes.length) { return false; }
    for (var i = 0; i < cartes.length; i++) {
      var c = cartes[i];
      var e = c.querySelector('.wl-ech');
      if (!e) { continue; }
      var rc = c.getBoundingClientRect();
      if (rc.height < 4) { continue; }              /* carte pas encore dessinee */
      /* geometrie degeneree (bande 769-999 px ou mise en page pas posee) :
         une correction relative sur des mesures absurdes s'emballe — on
         s'abstient tant que la carte n'a pas une largeur plausible. */
      if (rc.width < 40) { continue; }
      var bord = parseFloat(getComputedStyle(c).borderTopWidth) || 0;
      var actuelle = parseFloat(getComputedStyle(e).marginTop) || 0;
      var ecart = e.getBoundingClientRect().top - (rc.top + bord);
      if (Math.abs(ecart) < 0.5) { continue; }      /* deja a fleur */
      var voulue = Math.round((actuelle - ecart) * 10) / 10;
      e.style.setProperty('margin-top', voulue + 'px', 'important');
    }
    return true;
  }

  /* ==================================================================
     J. LA LIGNE KLARNA, RACCOURCIE
     ==================================================================
     Le theme ecrit « ou payez en 3x 110,00 € sans frais avec Klarna. ».
     On veut « ou 3x 110,00 € avec Klarna ».
     « sans frais » est masque par la feuille de style. Restent deux mots
     de liaison et un point final, qui vivent dans des noeuds de texte —
     inaccessibles au style, donc traites ici.

     LES VINGT ET UNE LANGUES : le raccourci du debut ne s'applique que si
     l'on reconnait la tournure francaise. Ailleurs, la ligne garde les
     mots du theme, simplement debarrassee de « sans frais » et du point.
     Mieux vaut une phrase un peu plus longue qu'une phrase cassee. */
  function raccourcirKlarna() {
    var k = document.querySelector('.wlk-cs-modal .wlk-klarna-text') ||
            document.querySelector('.wlk-cs-modal .wlk-klarna-row');
    if (!k) { return false; }
    /* On masque les mentions de garantie — « sans frais », « zinsfrei »,
       « senza interessi » — sans jamais toucher au montant ni au nom du
       prestataire. Le critere ne compte pas les rangs : on masque un
       « strong » qui ne porte AUCUN chiffre et qui n'est pas le nom du
       prestataire. Le montant garde ses chiffres, « Klarna » garde son
       nom, le reste s'efface. */
    var forts = k.querySelectorAll('strong, b');
    for (var j = 0; j < forts.length; j++) {
      var f2 = forts[j];
      var mot = (f2.textContent || '').trim();
      var muet = mot && !/\d/.test(mot) && !/klarna|paypal|alma|scalapay|klarn/i.test(mot);
      if (muet && !f2.classList.contains('wlmod-muet')) { f2.classList.add('wlmod-muet'); }
      if (!muet && f2.classList.contains('wlmod-muet')) { f2.classList.remove('wlmod-muet'); }
    }

    var noeuds = k.childNodes;
    for (var i = 0; i < noeuds.length; i++) {
      var n = noeuds[i];
      if (n.nodeType !== 3) { continue; }
      var v = n.nodeValue;
      var neuf = v;
      /* « ou payez en » -> « ou » (francais uniquement) */
      neuf = neuf.replace(/\bpayez\s+en\b/i, '');
      /* le point final, dans toutes les langues */
      neuf = neuf.replace(/\s*\.\s*$/, '');
      /* les espaces en double laisses par les retraits */
      neuf = neuf.replace(/\s{2,}/g, ' ');
      if (neuf !== v) { n.nodeValue = neuf; }
    }
    if (!k.dataset.wlmodKlarna && window.MutationObserver) {
      k.dataset.wlmodKlarna = '1';
      /* Le theme reecrit cette ligne a chaque changement de prix : on
         repasse derriere lui. On n'ecrit que si le texte differe, donc
         l'observateur ne se rappelle pas indefiniment. */
      new MutationObserver(raccourcirKlarna).observe(k, {
        childList: true, characterData: true, subtree: true
      });
    }
    return true;
  }

  /* ==================================================================
     K. LES DEUX NOMS DE MATIERE SUR DEUX LIGNES
     ==================================================================
     « Verre Acrylique » se repliait naturellement sur deux lignes, « Alu
     Dibond » tenait sur une : les deux cartes n'avaient pas le meme
     nombre de lignes, et l'oeil le voyait. On coupe donc les DEUX noms a
     leur espace, pour qu'ils occupent la meme hauteur.

     C'est ecrit pour les vingt et une langues : on ne connait aucun des
     deux mots, on coupe simplement au PREMIER espace. Un nom d'un seul
     mot reste sur une ligne — il n'y a rien a couper, et forcer une
     cesure y ferait plus de mal que de bien. */
  function couperLesNoms() {
    if (window.matchMedia('(min-width: 1000px)').matches) { return true; }
    var noms = document.querySelectorAll('.wlk-cs-modal .wlk-material__btn .wl-nm');
    if (!noms.length) { return false; }

    /* « Alu<br>Dibond » se lit « AluDibond » par textContent : un retour a
       la ligne ne compte pas comme un espace. On le remet, sinon un nom
       deja coupe passerait pour un mot unique au passage suivant. */
    function lireNom(el) {
      return (el.innerHTML || '').replace(/<br\s*\/?>/gi, ' ')
                                 .replace(/<[^>]*>/g, '')
                                 .replace(/\s+/g, ' ').trim();
    }

    var tous = [];
    for (var v = 0; v < noms.length; v++) { tous.push(lireNom(noms[v])); }

    /* LA COUPE N'EGALISE QUE SI TOUS LES NOMS ONT UN ESPACE.
       En francais, « Verre Acrylique » et « Alu Dibond » en ont un chacun :
       coupes, ils font deux lignes chacun, et les cartes se repondent.
       En neerlandais le premier est « Acrylglas », un seul mot, qui reste
       sur une ligne : couper l'autre ne les egalisait plus du tout, ca les
       desequilibrait dans l'autre sens en ajoutant une ligne a la carte.
       Des qu'un seul nom est insecable, on ne coupe personne. */
    var coupables = true;
    for (var w = 0; w < tous.length; w++) {
      if (tous[w].indexOf(' ') < 1) { coupables = false; break; }
    }

    for (var i = 0; i < noms.length; i++) {
      var n = noms[i];
      var texte = tous[i];
      var espace = texte.indexOf(' ');
      if (coupables && espace > 0) {
        if (n.querySelector('br')) { continue; }        /* deja coupe */
        n.textContent = '';
        n.appendChild(document.createTextNode(texte.slice(0, espace)));
        n.appendChild(document.createElement('br'));
        n.appendChild(document.createTextNode(texte.slice(espace + 1)));
      } else if (n.querySelector('br')) {
        /* une coupe posee par un passage precedent, devenue inutile */
        n.textContent = texte;
      }
    }
    return true;
  }

  function placerLaCroix() {
    var m = document.querySelector('.wlk-cs-modal');
    if (!m) { return false; }
    if (window.matchMedia('(min-width: 1000px)').matches) { return true; }

    /* La croix doit rester DANS la feuille : c'est la seule facon qu'elle
       ne bouge pas. Si une version precedente l'avait sortie dans le
       voile, on la ramene. */
    var voile = document.querySelector('.wlk-popup-overlay');
    var f = (voile && voile.querySelector(':scope > .wlk-cs-modal__close')) ||
            m.querySelector('.wlk-cs-modal__close');
    if (!f) { return false; }
    f.style.removeProperty('top');
    f.style.removeProperty('right');

    /* La tete : une bande qui ne defile pas, tout en haut de la feuille. */
    var tete = m.querySelector(':scope > .wlmod-tete');
    if (!tete) {
      tete = document.createElement('div');
      tete.className = 'wlmod-tete';
      m.insertBefore(tete, m.firstChild);
    }
    if (m.firstChild !== tete) { m.insertBefore(tete, m.firstChild); }
    if (f.parentElement !== tete) { tete.appendChild(f); }

    /* On coupe la feuille en deux : la croix d'un cote, TOUT LE RESTE dans
       un corps qui defile. Rien a calculer, rien a recalculer. */
    var corps = m.querySelector(':scope > .wlmod-corps');
    if (!corps) {
      corps = document.createElement('div');
      corps.className = 'wlmod-corps';
      m.appendChild(corps);
    }
    function ranger() {
      var enfants = [].slice.call(m.children);
      var bouge = 0;
      for (var i = 0; i < enfants.length; i++) {
        var e = enfants[i];
        if (e === corps || e === f || e === tete) { continue; }
        corps.appendChild(e);
        bouge += 1;
      }
      return bouge;
    }
    ranger();

    /* LE POINT QUI M'AVAIT ECHAPPE : ce rangement n'etait fait qu'une fois.
       Le theme construit le contenu de la feuille au premier appel et
       continue d'y ajouter des morceaux ensuite — un message d'erreur, un
       bandeau de succes, une info. Chacun de ces morceaux devenait enfant
       DIRECT de la feuille, hors du corps : la feuille se remettait a
       defiler, et la croix repartait avec elle.
       On surveille donc la feuille en continu. On ne bouge que ce qui est
       mal place, donc l'observateur ne se rappelle pas indefiniment. */
    if (!m.dataset.wlmodRangement && window.MutationObserver) {
      m.dataset.wlmodRangement = '1';
      new MutationObserver(function () {
        if (ranger()) { callerLesEchantillons(); couperLesNoms(); }
      }).observe(m, { childList: true });
    }
    return true;
  }
  window.addEventListener('resize', placerLaCroix);

  function essayer() {
    var a = surveillerLesTarifs();
    var b = poserLeBoutonDuBas();
    libererLeChoixDePhoto();
    var c = poserLeChoixSurMesure();
    var d = brancherLaLoupeDesFinitions();
    var e = ajusterLePoids();
    var f = surveillerLesFenetres();
    placerLaCroix();
    callerLesEchantillons();
    raccourcirKlarna();
    couperLesNoms();
    return a && b && c && d && e && f;
  }

  if (!essayer()) {
    var n = 0;
    var t = window.setInterval(function () {
      n += 1;
      if (essayer() || n > 40) { window.clearInterval(t); }
    }, 250);
  }

  /* LES RECALAGES DE L'OUVERTURE, AVANT LA PREMIERE PEINTURE. Les
     minuteries de 120 ms plus bas laissaient la premiere image peinte a
     l'ancienne : le client voyait la fenetre se rajuster sous ses yeux.
     La callback d'un MutationObserver s'execute avant la peinture qui
     suit le basculement de classe : tout est deja en place quand la
     fenetre apparait. Les minuteries restent en filet de securite —
     idempotentes, elles ne trouvent plus rien a changer. */
  (function () {
    var feuille = document.querySelector('.wlk-popup-overlay');
    if (!feuille || !window.MutationObserver) { return; }
    var etaitOuverte = feuille.classList.contains('open') ||
                       feuille.classList.contains('active');
    new MutationObserver(function () {
      var ouverte = feuille.classList.contains('open') ||
                    feuille.classList.contains('active');
      if (ouverte && !etaitOuverte) {
        poserLeChoixSurMesure();
        ajusterLePoids();
        placerLaCroix();
        callerLesEchantillons();
        raccourcirKlarna();
        couperLesNoms();
      }
      etaitOuverte = ouverte;
    }).observe(feuille, { attributes: true, attributeFilter: ['class'] });
  })();

  /* Le champ peut etre reconstruit par le theme : on repasse a chaque
     ouverture du visualisateur. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    if (e.target.closest('.wls-mur, .wv-btn-main, .wv-upload-area')) {
      window.setTimeout(libererLeChoixDePhoto, 60);
      window.setTimeout(libererLeChoixDePhoto, 600);
    }
    /* La feuille sur mesure est batie par le theme au premier appel : si
       notre boucle de depart a rendu les armes avant, le bloc de choix
       n'existe pas. On repasse a chaque ouverture. */
    if (e.target.closest('.wl-perso, .wlk-trigger, [data-wl-perso]')) {
      [120, 700, 1600].forEach(function (d) {
        window.setTimeout(function () {
          poserLeChoixSurMesure();
          ajusterLePoids();
          placerLaCroix();
          callerLesEchantillons();
          raccourcirKlarna();
          couperLesNoms();
        }, d);
      });
    }
    if (e.target.closest('.wl-cmp button, [data-wlf-ouvrir]')) {
      window.setTimeout(brancherLaLoupeDesFinitions, 300);
    }
    /* Choisir une matiere deplace la bordure epaisse d'une carte a
       l'autre : les deux ecarts changent, on les remesure. */
    if (e.target.closest('.wlk-material__btn')) {
      window.setTimeout(callerLesEchantillons, 50);
      window.setTimeout(callerLesEchantillons, 400);
    }
  }, true);
})();

;

/* ===================================================================
   WL-VIS : renumerotation des etapes
   ===================================================================
   Le visualisateur affichait « 1 » puis « 3 » : l'etape du milieu a ete
   retiree, mais les numeros sont ecrits en dur dans son gabarit.

   Ce gabarit fait partie des fichiers a ne pas toucher. On recompte donc
   ici, a l'ouverture de la modale.

   On RECOMPTE ce qui est visible plutot que de decaler d'un rang : si une
   autre etape disparait un jour, la suite reste juste sans qu'on y revienne.
   =================================================================== */
(function () {
  'use strict';

  function recompter() {
    var modale = document.querySelector('.wv-modal-overlay');
    if (!modale) { return; }
    var n = 0;
    Array.prototype.forEach.call(modale.querySelectorAll('.wv-step'), function (etape) {
      /* offsetParent vaut null des qu'un parent est masque : c'est le test le
         plus sur, il attrape aussi bien « display:none » sur l'etape que sur
         un conteneur au-dessus. */
      if (etape.offsetParent === null) { return; }
      var num = etape.querySelector('.wv-step-num');
      if (!num) { return; }
      n += 1;
      /* on n'ecrit que si la valeur change : sinon l'observateur se
         redeclencherait sur sa propre ecriture, en boucle. */
      if (num.textContent.trim() !== String(n)) { num.textContent = String(n); }
    });
  }

  /* A l'ouverture : la modale prend la classe « active ». On surveille cet
     attribut plutot qu'un clic, pour attraper aussi les ouvertures que le
     theme declenche lui-meme. */
  function surveiller() {
    var modale = document.querySelector('.wv-modal-overlay');
    if (!modale) { return false; }
    new MutationObserver(function () {
      if (modale.classList.contains('active')) { window.setTimeout(recompter, 60); }
    }).observe(modale, { attributes: true, attributeFilter: ['class'] });
    recompter();
    return true;
  }

  if (!surveiller()) {
    /* la modale est construite plus tard : on attend qu'elle arrive */
    var guet = new MutationObserver(function () {
      if (surveiller()) { guet.disconnect(); }
    });
    guet.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { guet.disconnect(); }, 15000);
  }
})();

;

/* ===================================================================
   WL-CALE : l apercu tient dans la fenetre
   ===================================================================
   Les trois vignettes sous l'apercu — montage, poids, fixations — etaient
   tranchees par le bas de la fenetre sur les tableaux VERTICAUX. Mesure :
   215 px sous le bord.

   L'image de fond change avec l'orientation :
       room-base.jpg           3461 x 3461   carree
       room-base-vertical.jpg  3461 x 4845   une fois et demie plus haute
   Elle occupe toute la largeur de la colonne, donc sa hauteur suit son
   rapport. En vertical elle prend une fois et demie plus de place et pousse
   les vignettes hors d'une fenetre plafonnee a 90 % de l'ecran.

   On borne donc la LARGEUR de l'apercu a ce que la hauteur disponible
   permet. Tout retrecit ensemble : l'image, son cadre, et l'oeuvre posee
   dessus — qui est placee en POURCENTAGE du cadre, et garde donc sa
   position exacte sur le mur.

   Rien n'est touche sous 1000 px : la fenetre y defile deja.
   =================================================================== */
(function () {
  'use strict';

  /* La largeur des reglages AVANT tout ajustement : elle fixe les
     proportions d'origine, on la mesure une fois et on s'y tient. */
  var largeurReglages = 0;

  /* Un style en ligne SIMPLE ne passe pas : une regle du theme est en
     !important, et la fenetre restait a 1254 px. Mesure : en ligne simple
     1254, en ligne avec important 855. Seul un « important » pose ici bat un
     « important » de feuille de style. */
  function poser(el, valeur) {
    if (!el) { return; }
    if (el.style.getPropertyValue('max-width') !== valeur) {
      el.style.setProperty('max-width', valeur, 'important');
    }
  }

  function appliquer(cadre, colonne, largeur) {
    var voulue = largeur + 'px';
    poser(cadre, voulue);
    poser(colonne, voulue);
    /* Sans borner AUSSI la fenetre, la colonne de reglages heritait de tout
       l'espace rendu par l'apercu : le bouton d'achat s'etirait sur 753 px. */
    var fenetre = document.querySelector('.wlk-cs-modal');
    if (fenetre && largeurReglages) {
      poser(fenetre, (largeur + largeurReglages) + 'px');
    }
  }

  /* On rend aux vignettes leur largeur d'origine : la rangee ET chacune
     d'elles, sinon un reglage precedent fausserait la mesure suivante. */
  function rendreLesVignettes(vignettes) {
    if (!vignettes) { return; }
    vignettes.style.removeProperty('max-width');
    vignettes.style.removeProperty('justify-content');
    vignettes.style.removeProperty('column-gap');
    Array.prototype.forEach.call(vignettes.querySelectorAll('.wlk-info-sq'),
      function (c) {
        c.style.removeProperty('max-width');
        c.style.removeProperty('flex');
      });
  }

  function caler() {
    var cadre = document.querySelector('.wlk-room-wrap');
    var fond = document.getElementById('wlk-room-bg');
    var colonne = document.querySelector('.wlk-cs-modal__preview');
    var reglages = document.querySelector('.wlk-cs-modal__controls');
    var vignettes = document.querySelector('.wlk-info-squares');
    var fenetre = document.querySelector('.wlk-cs-modal');
    if (!cadre || !fond || !colonne) { return; }

    /* sous 1000 px la fenetre defile : on rend sa largeur a tout le monde */
    if (window.innerWidth < 1000) {
      cadre.style.removeProperty('max-width');
      colonne.style.removeProperty('max-width');
      if (fenetre) { fenetre.style.removeProperty('max-width'); }
      rendreLesVignettes(vignettes);
      return;
    }
    if (!fond.naturalWidth || !fond.naturalHeight) { return; }

    /* On repart des proportions d'origine avant de mesurer : sinon chaque
       passage se calerait sur le reglage du precedent, et l'image
       retrecirait un peu plus a chaque ouverture. */
    cadre.style.removeProperty('max-width');
    colonne.style.removeProperty('max-width');
    if (fenetre) { fenetre.style.removeProperty('max-width'); }
    rendreLesVignettes(vignettes);

    var pleine = colonne.clientWidth;
    if (!pleine) { return; }
    /* offsetWidth : des pixels de mise en page, insensibles a
       l'animation d'ouverture (scale 0,95 -> 1) qui contaminait la
       mesure d'ecran de getBoundingClientRect. */
    if (reglages) { largeurReglages = reglages.offsetWidth; }

    var st = window.getComputedStyle(cadre);
    var margeHaute = (parseFloat(st.paddingTop) || 0) + (parseFloat(st.paddingBottom) || 0);
    var margeCote = (parseFloat(st.paddingLeft) || 0) + (parseFloat(st.paddingRight) || 0);
    var rapport = fond.naturalHeight / fond.naturalWidth;

    var carres = vignettes ? vignettes.querySelectorAll('.wlk-info-sq') : [];

    /* La taille des vignettes est FIXE. Auparavant je les reduisais par
       paliers jusqu'a ce que l'image retrouve sa place ; mais la colonne se
       resserre ensuite sur l'image, la mesure suivante repartait plus
       etroite, et les vignettes maigrissaient a chaque ouverture — 135 px,
       puis 111, puis 77. Une taille fixe ne peut pas deriver. */
    function reglerVignettes(taille) {
      if (!vignettes) { return; }
      vignettes.style.removeProperty('max-width');
      /* Centrees, et rapprochees de moitie. « space-between » les collait
         aux deux bords ; l'ecart avec celle du milieu valait alors tout
         l'espace libre partage en deux. On le ramene a la MOITIE : les deux
         vignettes exterieures font la moitie du chemin vers le centre, et il
         reste autant de marge sur les cotes qu'entre elles.

         L'ecart est donne en proportion et non en pixels : il se recalcule
         seul quand la colonne change de largeur, ce qui arrive a chaque
         changement d'orientation du tableau. Le « 100 % » d'un ecart se
         mesure sur la largeur interieure, marges deja deduites. */
      var occupe = taille * (carres.length || 3);
      vignettes.style.setProperty('justify-content', 'center', 'important');
      vignettes.style.setProperty('column-gap',
        'calc((100% - ' + occupe + 'px) / 4)', 'important');
      Array.prototype.forEach.call(carres, function (c) {
        c.style.setProperty('max-width', taille + 'px', 'important');
        c.style.setProperty('flex', '0 0 ' + taille + 'px', 'important');
      });
    }

    function largeurPossible() {
      var reste = colonne.clientHeight;
      Array.prototype.forEach.call(colonne.children, function (enfant) {
        if (enfant !== cadre) { reste -= enfant.offsetHeight; }
      });
      if (reste <= 0) { return 0; }
      var l = Math.floor((reste - margeHaute) / rapport + margeCote);
      return l > pleine ? pleine : l;
    }

    reglerVignettes(135);
    var largeur = largeurPossible();
    /* Un seul repli : sous 260 px l'apercu ne montrerait plus rien, les
       vignettes cedent alors une fois. */
    if (largeur < 260) {
      reglerVignettes(96);
      largeur = largeurPossible();
    }
    if (!isFinite(largeur) || largeur < 160) { return; }

    appliquer(cadre, colonne, largeur);
    /* le rabot court dans le meme geste : en deux temps (rattraper minute
       a +30 ms), chaque passe repeignait 539 puis 536 px — un battement
       de 3 px par passe. La mise en page est synchrone, on rabote avant
       toute peinture. La minuterie reste en filet, elle ne trouvera plus
       rien a raboter. */
    rattraper();
    window.setTimeout(rattraper, 30);
  }

  function rattraper() {
    /* Le calcul part de la hauteur de la colonne, qui ignore les marges et
       bordures propres a la fenetre : il restait quelques pixels sous le
       bord. On mesure ce qui depasse et on retire juste ce qu'il faut. Une
       seule passe — cette fonction ne se rappelle jamais elle-meme. */
    var fenetre = document.querySelector('.wlk-cs-modal');
    var vignettes = document.querySelector('.wlk-info-squares');
    var cadre = document.querySelector('.wlk-room-wrap');
    var colonne = document.querySelector('.wlk-cs-modal__preview');
    var fond = document.getElementById('wlk-room-bg');
    if (!fenetre || !vignettes || !cadre || !colonne || !fond) { return; }
    if (!fond.naturalWidth || window.innerWidth < 1000) { return; }
    var trop = vignettes.getBoundingClientRect().bottom
             - fenetre.getBoundingClientRect().bottom;
    if (trop <= 0) { return; }
    /* les « bottom » sont des pixels d'ecran : pendant l'animation
       d'ouverture ils sont multiplies par l'echelle du moment. On la
       mesure (ecran / mise en page) et on la retire — le meme geste que
       recadrerApercu. */
    var echelle = fenetre.offsetHeight
      ? (fenetre.getBoundingClientRect().height / fenetre.offsetHeight) : 1;
    if (echelle > 0.5) { trop = trop / echelle; }
    var rapport = fond.naturalHeight / fond.naturalWidth;
    var actuelle = parseFloat(cadre.style.maxWidth)
                || cadre.offsetWidth;
    var reduite = Math.floor(actuelle - (trop / rapport) - 2);
    if (reduite >= 160 && reduite < actuelle) { appliquer(cadre, colonne, reduite); }
  }

  function brancher() {
    var fenetre = document.querySelector('.wlk-popup-overlay');
    var fond = document.getElementById('wlk-room-bg');
    if (!fenetre || !fond) { return false; }

    /* a l'ouverture — tout de suite, AVANT la premiere peinture : les
       mesures sont desormais en pixels de mise en page, justes meme
       pendant l'animation. Les minuteries restent en filet de securite. */
    new MutationObserver(function () {
      if (fenetre.classList.contains('open') || fenetre.classList.contains('active')) {
        caler();
        window.setTimeout(caler, 60);
        window.setTimeout(caler, 400);
      }
    }).observe(fenetre, { attributes: true, attributeFilter: ['class'] });

    /* quand l'image de fond change — c'est elle qui change tout */
    fond.addEventListener('load', function () { window.setTimeout(caler, 20); });
    new MutationObserver(function () { window.setTimeout(caler, 20); })
      .observe(fond, { attributes: true, attributeFilter: ['src'] });

    window.addEventListener('resize', function () { window.setTimeout(caler, 80); });
    caler();
    return true;
  }

  if (!brancher()) {
    var guet = new MutationObserver(function () { if (brancher()) { guet.disconnect(); } });
    guet.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { guet.disconnect(); }, 15000);
  }
})();

;

/* ===================================================================
   WL-AJUST : les libelles tiennent dans leur cadre
   ===================================================================
   En polonais, « kg szacunkowo » fait 140 px de large dans un carre de
   135, et « 140cm · Szerokość » deborde de sa propre boite. Ces libelles
   ont une taille de police calibree sur le francais — « kg estime »,
   « 140cm · Largeur » — et rien ne rattrapait la difference.

   On mesure donc la place reellement disponible et on descend la police
   par petits pas jusqu'a ce que le texte tienne, sans jamais passer sous
   un plancher lisible. Rien a regler langue par langue.
   =================================================================== */
(function () {
  'use strict';

  /* selecteur, plancher en pixels */
  var CIBLES = [
    ['.wlk-sq-weight-label', 9],
    /* 15 px etait encore trop haut : « 140cm · Szerokość » restait coupe */
    ['.wlk-dims__value', 10],
    ['.wlk-room-size-label', 9],
    /* la ligne Klarna sort du cadre de 11 px en polonais */
    ['.wlk-klarna-text', 10],
    ['.wlk-price-value', 16],
    /* Le libelle « cm · Szerokość » est un span AVEC SA PROPRE police fixe
       de 14 px : reduire celle du bloc parent ne le touchait pas, et il
       restait coupe meme a 10 px. On l'ajuste donc pour lui-meme. */
    ['.wlk-dims__value span', 8]
  ];

  /* Ce qui a deja ete calcule : texte + largeur disponible. Tant que ni
     l'un ni l'autre ne change, on ne retouche a rien — sans cette memoire
     l'ajustement se relancait a chaque mutation de la fenetre et le texte
     grandissait puis retrecissait, en boucle : ca clignotait. */
  var dejaFait = (typeof WeakMap === 'function') ? new WeakMap() : null;

  function ajuster(el, plancher) {
    if (!el || !el.parentElement) { return; }
    var parent = el.parentElement;
    var cs = window.getComputedStyle(parent);
    var dispo = parent.clientWidth
              - (parseFloat(cs.paddingLeft) || 0)
              - (parseFloat(cs.paddingRight) || 0);
    if (dispo <= 20) { return; }

    var empreinte = el.textContent + '|' + Math.round(dispo);
    var fini = dejaFait && dejaFait.get(el);
    if (fini === empreinte + '|plancher') {
      /* Deja descendu jusqu'au plancher lisible sans y arriver : il n'y a
         plus rien a tenter, et repasser a chaque battement ferait clignoter
         le texte pour rien. */
      return;
    }
    if (fini === empreinte) {
      /* Deja cale pour ce texte et cette largeur. Un memo doit eviter le
         travail inutile, jamais figer un defaut : on ne s'arrete ici que si
         le texte tient VRAIMENT. Sinon on repasse.

         C'est ce qui manquait : pose a un moment ou la fenetre n'avait pas
         encore sa largeur definitive, le memo interdisait ensuite tout
         rattrapage — « cm · Wysokość » restait a 14 px et mordait sur le
         trait de son cadre, alors que son voisin, lui, avait ete reduit. */
      if (!(el.getBoundingClientRect().width > dispo + 1)) { return; }
    }

    /* la taille d'origine, retenue une seule fois : on ne la redecouvre pas
       a chaque passage, sinon elle finirait par valoir la derniere reduction */
    var base = parseFloat(el.getAttribute('data-wl-base') || '');
    if (!base) {
      base = parseFloat(window.getComputedStyle(el).fontSize);
      if (!base) { return; }
      el.setAttribute('data-wl-base', base);
    }

    var taille = base;
    el.style.setProperty('font-size', taille + 'px', 'important');
    var garde = 0;
    while (garde < 30 && taille > plancher) {
      var trop = (el.scrollWidth > el.clientWidth + 1)
              || (el.getBoundingClientRect().width > dispo + 1);
      if (!trop) { break; }
      taille = taille - Math.max(0.5, taille * 0.06);
      if (taille < plancher) { taille = plancher; }
      el.style.setProperty('font-size', taille.toFixed(1) + 'px', 'important');
      garde += 1;
    }
    if (dejaFait) {
      /* On distingue « cale » de « descendu au plancher sans y arriver » :
         le premier peut etre remis en cause si la mise en page bouge, le
         second n'a plus rien a donner. */
      dejaFait.set(el, (taille <= plancher) ? (empreinte + '|plancher') : empreinte);
    }
  }

  function passer() {
    CIBLES.forEach(function (paire) {
      Array.prototype.forEach.call(document.querySelectorAll(paire[0]),
        function (el) { ajuster(el, paire[1]); });
    });
  }

  var enAttente = null;
  function bientot() {
    if (enAttente) { window.clearTimeout(enAttente); }
    enAttente = window.setTimeout(function () { enAttente = null; passer(); }, 60);
  }

  function brancher() {
    var fenetre = document.querySelector('.wlk-popup-overlay');
    if (!fenetre) { return false; }

    /* a l'ouverture */
    new MutationObserver(function () {
      if (fenetre.classList.contains('open') || fenetre.classList.contains('active')) {
        bientot();
      }
    }).observe(fenetre, { attributes: true, attributeFilter: ['class'] });

    /* a chaque changement de contenu : les dimensions se reecrivent des
       qu'on bouge la reglette. Une taille de police ne declenche pas cet
       observateur — pas de boucle possible. */
    new MutationObserver(bientot)
      .observe(fenetre, { childList: true, subtree: true, characterData: true });

    window.addEventListener('resize', bientot);
    /* pas d'ajustement pendant la course au premier ecran (49 ms
       d'ajustements forces mesures) — mais un premier passage au CALME,
       apres le chargement complet : la fenetre est ainsi deja ajustee
       longtemps avant qu'un humain ne l'ouvre, et l'ouverture ne montre
       aucun recalage. */
    window.addEventListener('load', function () {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(bientot, { timeout: 4000 });
      } else {
        window.setTimeout(bientot, 1500);
      }
    });
    return true;
  }

  if (!brancher()) {
    var guet = new MutationObserver(function () { if (brancher()) { guet.disconnect(); } });
    guet.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { guet.disconnect(); }, 15000);
  }
})();
